import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { getCollectionCourseListService } from 'src/api/collection'
import { getCollectionCourseListSuccess } from 'src/reducers/collection/action'
import { GET_COLLECTION_COURSE_LIST } from 'src/reducers/collection/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* collectionCourseListFlow(payload) {
  try {
    const { id, callback } = payload

    const response = yield call(getCollectionCourseListService, id)

    yield put(getCollectionCourseListSuccess(response.data))
    yield put(operationSuccess())

    if (callback) callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* collectionCourseListWatcher() {
  while (true) {
    const action = yield takeMaybe(GET_COLLECTION_COURSE_LIST)
    const { payload } = action

    // Page loads show their own loading state; no full-screen overlay.
    yield fork(generalSaga, collectionCourseListFlow, payload, false)
  }
}
